import type { DeleteThirdPartyMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteThirdPartyDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * The tRPC delete returns void and throws if no rows are affected, so we
 * hardcode a success-shaped response mirroring the GraphQL mutation structure.
 * Only delete_third_party_by_pk.Id is meaningful (the deleted id).
 */
const mapTrpcResponseToGraphQL = (id: string): DeleteThirdPartyMutation => {
  return {
    delete_questionnaire_invite: {
      __typename: 'questionnaire_invite_mutation_response',
      affected_rows: 0,
    },
    delete_third_party_response: {
      __typename: 'third_party_response_mutation_response',
      affected_rows: 0,
    },
    delete_third_party_by_pk: {
      __typename: 'third_party',
      Id: id,
    },
  };
};

export const useDeleteThirdParty = createMutationHook({
  name: 'deleteThirdParty',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.thirdParty.delete.mutationOptions({ onSuccess }),
  mapInput: (id: string) => ({ id }),
  invalidate: (trpc) => [
    trpc.frontend.thirdParty.register.queryKey(),
    trpc.frontend.thirdParty.getById.queryKey(),
  ],
  mapResponse: (_result, id: string): DeleteThirdPartyMutation =>
    mapTrpcResponseToGraphQL(id),
  graphqlDocument: DeleteThirdPartyDocument,
  graphqlVariables: (id: string) => ({ Id: id }),
  evictFields: ['third_party', 'third_party_by_pk'],
});
